module.exports = __webpack_public_path__ + "img/kiribati.c563879f.png";